import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export type PaymentRemoveFromBillParams = {
  paymentId: string;
  billId: string;
};

export const paymentRemoveFromBillAtom = createMutationAtomFactory(
  'finance.paymentRemoveFromBill',
  (params: PaymentRemoveFromBillParams) => ({
    financePaymentRemoveFromBill: {
      __args: {
        paymentId: params.paymentId,
        billId: params.billId,
      },
      id: true,
      documentNumber: true,
      status: true,
      bills: {
        bill: {
          id: true,
          documentNumber: true,
        },
        appliedAmount: {
          amount: true,
          currencyCode: true,
        },
        appliedAt: true,
      },
      timestamps: {
        updatedAt: true,
      },
    },
  }),
);
